import { useEffect, useState } from "react";

const ACTIVE_STAGE_KEY = "pfjudgepro-active-stage";

export default function useActiveStage(userId) {
  const [activeStage, setActiveStage] = useState("Constructive");

  useEffect(() => {
    if (!userId) return;
    const key = `${ACTIVE_STAGE_KEY}-${userId}`;
    setActiveStage(sessionStorage.getItem(key) || "Constructive");
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    sessionStorage.setItem(`${ACTIVE_STAGE_KEY}-${userId}`, activeStage);
  }, [activeStage, userId]);

  return { activeStage, setActiveStage };
}